





























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DisciplineListItemDTO } from '@bookings/interfaces/online-bookings';

@Component({
  name: 'bpc-discipline-selector',
  components: {},
})
export default class DisciplineSelector extends Vue {
  @Prop(Object) readonly value: DisciplineListItemDTO;
  @Prop(Array) readonly options: DisciplineListItemDTO[];

  showModal = false;

  get model() {
    return this.value;
  }

  set model(value: DisciplineListItemDTO) {
    this.$emit('input', value);
  }

  selectDiscipline(discipline: DisciplineListItemDTO) {
    this.model = discipline;
    this.showModal = false;
  }
}
